interface UserCompaniesIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

const UserCompaniesIcon = ({ width = 64, height = 64, className }: UserCompaniesIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden
  >
    <g clipPath="url(#clip0_user_companies_icon)">
      <path
        d="M46.4517 28.3869V29.1113C46.4517 29.9989 46.5948 30.8807 46.8754 31.7227L48.5162 36.6449H51.6129V25.29H49.5484C47.8382 25.2902 46.4517 26.6765 46.4517 28.3869Z"
        fill="#5A4146"
      />
      <path
        d="M60.5855 30.5316L58.8387 36.6453L50.5806 29.4195C49.4404 29.4195 48.5161 28.4952 48.5161 27.3551C48.5161 25.6448 49.9026 24.2583 51.6129 24.2583H58.8386C59.9789 24.2583 60.9031 25.1827 60.9031 26.3228V28.2631C60.9032 29.0302 60.7962 29.7937 60.5855 30.5316Z"
        fill="#694B4B"
      />
      <path d="M56.7736 39.7427H50.5801V44.3113H56.7736V39.7427Z" fill="#E6AF78" />
      <path
        d="M50.5806 41.6378C51.5379 42.0268 52.5819 42.2458 53.6773 42.2458C54.7727 42.2458 55.8167 42.0268 56.7741 41.6378V39.7417H50.5806V41.6378Z"
        fill="#D29B6E"
      />
      <path
        d="M61.754 43.669L56.774 42.2462L53.6775 44.3011L50.5807 42.2461L45.601 43.669C44.2715 44.0488 43.355 45.264 43.355 46.6466V54.1936C43.355 54.7637 43.8171 55.2258 44.3872 55.2258H62.9679C63.538 55.2258 64.0001 54.7637 64.0001 54.1936V46.6466C64.0001 45.2638 63.0835 44.0488 61.754 43.669Z"
        fill="#D5DCED"
      />
      <path d="M54.7095 55.2257H52.645L53.1611 44.3105H54.1934L54.7095 55.2257Z" fill="#AFB9D2" />
      <path
        d="M53.6774 40.7743C50.2568 40.7743 47.4839 38.0013 47.4839 34.5808V33.3715C47.4839 32.824 47.7014 32.2988 48.0885 31.9116L49.9604 30.0397C50.3568 29.6433 50.8988 29.4155 51.459 29.4331C54.7588 29.5372 57.6795 30.2441 59.2761 31.8035C59.667 32.1852 59.871 32.7192 59.871 33.2655V34.5808C59.871 38.0015 57.098 40.7743 53.6774 40.7743Z"
        fill="#F0C087"
      />
      <path
        d="M50.5806 33.6271C50.5806 32.4363 51.5806 31.4898 52.769 31.5656C54.8529 31.6986 57.9451 32.0468 59.8423 32.9593C59.7804 32.5238 59.5933 32.1127 59.2761 31.803C57.6795 30.2436 54.7588 29.5367 51.459 29.4326L51.4589 29.4327C50.8988 29.4151 50.3566 29.643 49.9604 30.0392L48.0886 31.911C47.7014 32.2981 47.4839 32.8232 47.4839 33.3708V34.5802C47.4839 37.4047 49.3765 39.7828 51.9614 40.5276C51.101 39.4661 50.5808 38.1186 50.5808 36.6447L50.5806 33.6271Z"
        fill="#E6AF78"
      />
      <path
        d="M59.8711 49.7224C59.8711 48.901 60.1973 48.1134 60.7781 47.5326L63.4352 44.8755C63.7903 45.3831 64.0001 45.9942 64.0001 46.6466V54.1936C64.0001 54.7637 63.538 55.2259 62.9678 55.2259H59.8711V49.7224Z"
        fill="#C7CFE2"
      />
      <path
        d="M54.1934 46.375H53.1611C52.8761 46.375 52.645 46.1439 52.645 45.8589V44.3105H54.7095V45.8589C54.7095 46.1439 54.4785 46.375 54.1934 46.375Z"
        fill="#959CB5"
      />
      <path
        d="M53.6773 44.3011L51.9277 45.6375C51.6263 45.8677 51.1906 45.7755 51.0085 45.4427L49.439 42.5765L50.0707 41.6128C50.2108 41.3991 50.5095 41.3627 50.6968 41.5365L53.6773 44.3011Z"
        fill="#C7CFE2"
      />
      <path
        d="M53.6772 44.301L55.4269 45.6375C55.7282 45.8677 56.164 45.7755 56.3461 45.4427L57.9156 42.5765L57.2839 41.6128C57.1437 41.3991 56.8451 41.3627 56.6577 41.5365L53.6772 44.301Z"
        fill="#C7CFE2"
      />
      <path
        d="M18.4778 40.3432C17.5957 38.0059 16.896 33.988 16.7449 31.8962C16.4574 27.9154 13.4575 24.6704 9.40229 24.6704C5.34704 24.6704 2.34717 27.9155 2.05967 31.8962C1.90854 33.9879 1.20892 38.0059 0.326794 40.3432C0.132419 40.8584 0.356794 41.4265 0.864169 41.6565C1.80942 42.0849 3.82479 42.9242 6.25542 43.251H12.549C14.9683 42.9234 16.9978 42.0837 17.9403 41.6565C18.4478 41.4265 18.6722 40.8584 18.4778 40.3432Z"
        fill="#5A4146"
      />
      <path
        d="M17.9402 41.6565C18.4475 41.4265 18.672 40.8584 18.4775 40.3432C17.5955 38.0059 16.8957 33.988 16.7447 31.8962C16.4573 27.9154 13.4573 24.6704 9.40222 24.6704C9.39197 24.6704 9.38184 24.6704 9.37159 24.6705C6.25997 24.6832 5.16034 28.9268 7.83897 30.5102C7.99984 30.6053 8.10297 30.651 8.10297 30.651L10.4491 43.251H12.549C14.9682 42.9232 16.9977 42.0835 17.9402 41.6565Z"
        fill="#694B4B"
      />
      <path
        d="M16.8687 45.3237L13.5282 43.6536C12.8287 43.3038 12.3869 42.5888 12.387 41.8068L12.3872 38.71H6.1935V41.807C6.1935 42.589 5.75175 43.3037 5.05225 43.6535L1.71175 45.3237C0.662625 45.8482 0 46.9205 0 48.0933V54.1936C0 54.7636 0.462125 55.2258 1.03225 55.2258H17.5484C18.1185 55.2258 18.5806 54.7636 18.5806 54.1936V48.0935C18.5806 46.9205 17.9179 45.8482 16.8687 45.3237Z"
        fill="#E6AF78"
      />
      <path
        d="M9.29032 42.8385C10.4018 42.8385 11.4664 42.6093 12.4424 42.2015C12.4168 42.0713 12.3869 41.942 12.3869 41.8063L12.3872 38.7095H6.19345V41.8065C6.19345 41.9428 6.16357 42.0728 6.1377 42.2035C7.11432 42.6092 8.17844 42.8385 9.29032 42.8385Z"
        fill="#D29B6E"
      />
      <path
        d="M16.8687 45.3233L14.489 44.1334C13.3855 45.8374 11.4716 46.9676 9.29037 46.9676C7.10912 46.9676 5.19513 45.8374 4.09163 44.1333L1.71187 45.3233C0.66275 45.8478 0 46.9201 0 48.0929V54.1932C0 54.7633 0.462125 55.2254 1.03225 55.2254H17.5484C18.1185 55.2254 18.5806 54.7633 18.5806 54.1932V48.0931C18.5806 46.9201 17.9179 45.8478 16.8687 45.3233Z"
        fill="#D5DCED"
      />
      <path
        d="M9.29045 40.7743C6.14145 40.7743 3.54145 38.4243 3.14833 35.3825C3.09133 34.9417 3.3032 34.5096 3.69995 34.3095C4.1752 34.0697 4.86583 33.6655 5.52708 33.0755C6.26345 32.4185 6.69545 31.7256 6.93945 31.217C7.14958 30.779 7.63258 30.5312 8.10332 30.6513C11.7378 31.5783 14.2122 33.4692 15.11 34.2412C15.351 34.4485 15.4898 34.7541 15.4651 35.0711C15.215 38.2623 12.5461 40.7743 9.29045 40.7743Z"
        fill="#F0C087"
      />
      <path
        d="M15.1098 34.2407C14.2122 33.4687 11.7377 31.5778 8.10317 30.6508C7.63242 30.5307 7.14942 30.7785 6.93929 31.2165C6.75454 31.6017 6.44917 32.0925 5.99604 32.5935C5.99592 32.5947 5.99554 32.5957 5.99542 32.597C5.85479 32.7563 5.70504 32.9161 5.52704 33.0751C4.86579 33.6652 4.17517 34.0693 3.69992 34.3091C3.30317 34.5092 3.09142 34.9415 3.14829 35.3822C3.50142 38.1141 5.63917 40.2886 8.35142 40.7033C7.11554 39.8626 6.19367 38.7063 6.19367 36.6451V35.1731C6.42817 35 6.66429 34.8273 6.90154 34.6156C7.47529 34.1036 7.97617 33.5115 8.37779 32.874C11.1582 33.7416 13.0432 35.1867 13.7578 35.8012C13.9534 35.9727 14.4389 36.4202 15.0069 36.9531C15.2513 36.365 15.4129 35.734 15.4648 35.0708C15.4897 34.7537 15.3508 34.4481 15.1098 34.2407Z"
        fill="#E6AF78"
      />
      <path
        d="M0.62925 46.2324C0.231625 46.7602 0 47.4075 0 48.0932V54.1934C0 54.7635 0.462125 55.2257 1.03225 55.2257H4.129V50.0244C4.129 49.3973 3.84387 48.804 3.35413 48.4123L0.62925 46.2324Z"
        fill="#C7CFE2"
      />
      <path
        d="M46.8304 43.9147L38.1935 40.7739L32 42.8386L25.8065 40.7741L17.1697 43.9148C15.5379 44.5082 14.4517 46.0589 14.4517 47.7952V54.1934C14.4517 54.7634 14.9138 55.2257 15.4839 55.2257H48.5162C49.0863 55.2257 49.5484 54.7634 49.5484 54.1934V47.7952C49.5484 46.0588 48.4623 44.5081 46.8304 43.9147Z"
        fill="#289FD5"
      />
      <path d="M30.9187 44.9033L29.9355 55.2257H34.0645L33.0814 44.9033H30.9187Z" fill="#707487" />
      <path
        d="M33.084 46.3216H30.9165C30.5173 46.3216 30.1938 45.9981 30.1938 45.599V42.8389H33.8065V45.599C33.8066 45.998 33.4831 46.3216 33.084 46.3216Z"
        fill="#5B5D6E"
      />
      <path
        d="M48.4374 44.9819C49.1344 45.7301 49.5485 46.7264 49.5485 47.7952V54.1934C49.5485 54.7636 49.0864 55.2257 48.5162 55.2257H43.355V51.7747C43.355 50.6796 43.79 49.6293 44.5644 48.8551L48.4374 44.9819Z"
        fill="#0E80B4"
      />
      <path
        d="M43.3548 19.4859V10.8384C43.3548 9.69818 42.4304 8.77393 41.2903 8.77393H28.9031C24.3424 8.77393 20.645 12.4712 20.645 17.0321V19.4859C20.645 20.5954 20.8239 21.6977 21.1748 22.7502L21.5184 23.7811C21.6236 24.0968 21.6773 24.4274 21.6773 24.7603V25.2901H42.3224V24.7603C42.3224 24.4274 42.376 24.0968 42.4813 23.7811L42.8249 22.7502C43.1759 21.6976 43.3548 20.5953 43.3548 19.4859Z"
        fill="#5A4146"
      />
      <path
        d="M25.8066 12.9674C25.8066 15.2834 27.6841 17.1609 30.0001 17.1609H30.5808L30.861 25.2899H42.3226V24.7602C42.3226 24.4273 42.3763 24.0967 42.4815 23.7809L42.8251 22.7501C43.176 21.6976 43.3549 20.5953 43.3549 19.4858V10.8384C43.3549 9.69818 42.4305 8.77393 41.2904 8.77393H30.0001C27.6841 8.77393 25.8066 10.6514 25.8066 12.9674Z"
        fill="#694B4B"
      />
      <path d="M38.1937 33.5488H25.8062V42.8388H38.1937V33.5488Z" fill="#E6AF78" />
      <path
        d="M25.8063 37.0388C27.6298 38.0952 29.7409 38.7096 31.9998 38.7096C34.2587 38.7096 36.3699 38.0952 38.1933 37.0388V33.5483H25.8062L25.8063 37.0388Z"
        fill="#D29B6E"
      />
      <path
        d="M32.0002 42.8384L28.7079 46.1307C28.2654 46.5732 27.5341 46.5233 27.1558 46.0248L23.7422 41.5268L24.6351 39.6452C24.8986 39.0899 25.5858 38.8864 26.1091 39.2089L32.0002 42.8384Z"
        fill="#0E80B4"
      />
      <path
        d="M32 42.8384L35.2923 46.1307C35.7348 46.5732 36.4661 46.5233 36.8444 46.0248L40.258 41.5268L39.3651 39.6452C39.1016 39.0899 38.4144 38.8864 37.8911 39.2089L32 42.8384Z"
        fill="#0E80B4"
      />
      <path
        d="M31.9999 36.6451C26.2989 36.6451 21.6772 32.0235 21.6772 26.3225V25.1131C21.6772 24.5656 21.8947 24.0405 22.2819 23.6532L23.137 22.7981C23.5241 22.411 23.7416 21.8859 23.7416 21.3382V18.8637C23.7416 18.3857 24.0626 17.9705 24.5277 17.8606C26.9691 17.284 34.5662 15.9181 39.7364 19.7206C40.0721 19.9675 40.2577 20.3731 40.2577 20.7899V21.3382C40.2577 21.8857 40.4752 22.4109 40.8624 22.7981L41.7175 23.6532C42.1046 24.0404 42.3221 24.5655 42.3221 25.1131V26.3225C42.3225 32.0235 37.7009 36.6451 31.9999 36.6451Z"
        fill="#F0C087"
      />
      <path
        d="M39.7365 19.7208C36.1002 17.0465 31.2701 16.9307 27.8709 17.2968C26.437 17.4512 25.2522 17.6898 24.528 17.8608C24.0629 17.9707 23.7419 18.386 23.7419 18.864V21.3383C23.7419 21.886 23.5244 22.4111 23.1371 22.7983L22.282 23.6535C21.8947 24.0407 21.6772 24.5658 21.6772 25.1135V26.3227C21.6772 31.6007 25.641 35.9458 30.7525 36.5627C28.9714 34.7078 27.8707 32.1942 27.8707 29.4195V21.8743C27.8707 20.8282 28.6486 19.954 29.6865 19.8238C32.1637 19.5132 36.701 19.3265 40.2577 21.3386V20.7901C40.258 20.3733 40.072 19.9676 39.7365 19.7208Z"
        fill="#E6AF78"
      />
      <path
        d="M15.5628 44.9819C14.8658 45.7301 14.4517 46.7264 14.4517 47.7952V54.1934C14.4517 54.7636 14.9138 55.2257 15.4839 55.2257H20.6452V51.7747C20.6452 50.6796 20.2102 49.6293 19.4358 48.8551L15.5628 44.9819Z"
        fill="#0E80B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_user_companies_icon">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default UserCompaniesIcon;
